import * as React from 'react';

import type { ApolloError } from '@apollo/client';
import { useQuery } from '@apollo/client';

import { useParams } from 'js/lib/useRouter';

import type { AdminGlobalPartnerFragment } from '../__queries__/__generated__/adminGlobalPartnerFragment';
import type {
  GetPartnerBySlugQuery,
  GetPartnerBySlugQueryVariables,
} from '../__queries__/__generated__/getPartnerBySlug';
import getPartnerBySlug from '../__queries__/getPartnerBySlug.graphql';
import { ROUTE_ARGUMENTS } from '../analytics/constants';

export interface PartnerContextType {
  partner: AdminGlobalPartnerFragment | undefined | null;
  loading: boolean;
  error?: ApolloError | { message: string };
}

const PartnerContext = React.createContext<PartnerContextType>({
  partner: undefined,
  loading: false,
});

/**
 * Access the current partner for the page context
 */
export const usePartner = () => React.useContext(PartnerContext);

/**
 * Provides access for Admin V2 to the current partner via usePartner
 */
export const AdminPartnerProvider = ({ children }: { children: React.ReactNode }) => {
  const params = useParams();
  const slug = params[ROUTE_ARGUMENTS.INSTITUTION_SLUG];

  const { loading, error, ...result } = useQuery<GetPartnerBySlugQuery, GetPartnerBySlugQueryVariables>(
    getPartnerBySlug,
    {
      variables: {
        // @ts-expect-error TS2769 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
        slug,
      },
      context: { clientName: 'gatewayGql' },
      skip: !slug,
    }
  );

  const context: PartnerContextType = {
    loading,
    partner: result.data?.Partner?.queryBySlug,
    error,
  };

  return <PartnerContext.Provider value={context}>{children}</PartnerContext.Provider>;
};
